import { useNavigate } from 'react-router-dom';
import { useParams } from "react-router-dom";
import {SettingsContext} from '../components/userSettingsContext';
import { useState, useEffect, useContext, useMemo, useRef, forwardRef, useImperativeHandle  } from "react"

import {CcStepper2, StepperNavButtons} from "../commonComponents/stepper"
import { CcActionButton, CcTitle, CcSubSectionTitle, CcActionButtonOutlined } from "../commonComponents/styledTexts";
import {ExclamationCircleIcon } from '@heroicons/react/20/solid'

import {Dialog, DialogActions, IconButton, Radio  } from '@mui/material';

import dayjs from 'dayjs';
import axios from 'axios';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';

import {CcLoader, InfoToolTip, LionLoaderGradient} from '../commonComponents/generalComponents'
import {SnippetCodeViewer} from '../commonComponents/snippetGeneric'
import {CcCheckbox, InputNumber, InputText, InputURL, FileSelector, LionCombo, LionListbox, LockToggleButton} from '../commonComponents/inputFields'


import { Icon as Iconify } from '@iconify/react';

import { getErrorListFromYupError, getErrorMessage, getErrorMessageForArray, snippetDataValidationSchemaSlidingPuzzle } from '../components/helperErrors'
import { ccColorTeal, ccColorDarkTeal } from '../components/helpersStyles';
import {LionColorPicker, LionMultiColorPicker}  from '../components/lionColorPicker';
import { lionIcons } from '../components/helpersIcons';

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { GetImageSize } from '../components/helpers';
import { GridIcon } from '../components/helpersIcons';
//import React, { useEffect, useRef, useState, useMemo } from 'react';
import { Stage, Layer, Image as KonvaImage, Rect } from 'react-konva';
import { Tween } from 'konva';
import Konva from 'konva';
import { GoogleFontsSelector } from '../commonComponents/helperGoogleFonts';
import { GetSnippetIdfromSnippetHtml } from '../components/helpers';

function downloadDataURLImages(dataUrls, baseFilename = "image") {
  dataUrls.forEach((dataUrl, index) => {
    // Convert DataURL to Blob
    const [header, base64] = dataUrl.split(",");
    const mime = header.match(/:(.*?);/)[1];
    const binary = atob(base64);
    const array = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      array[i] = binary.charCodeAt(i);
    }
    const blob = new Blob([array], { type: mime });

    // Create a link and trigger the download
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `${baseFilename}_${index + 1}.${mime.split("/")[1]}`;
    document.body.appendChild(a); // Needed for Firefox
    a.click();
    document.body.removeChild(a);
  });
}


const PuzzleManager = forwardRef((props, ref) => {
  const [gridSize, setGridSize] = useState(3);
  //const [canvasSize, setCanvasSize] = useState(undefined);
  const [canvasWidth, setCanvasWidth] = useState(undefined);
  const [canvasHeight, setCanvasHeight] = useState(undefined);
  const [canvasKeepRatio, setCanvasKeepRatio] = useState(true);

  const [tiles, setTiles] = useState([]);
  const [image, setImage] = useState(null);
  const tileRefs = useRef({});

  const tilesRef = useRef([]); // Array of tile numbers (including EMPTY)
  const stageRef = useRef(null);


  const [animating, setAnimating] = useState(false);
  const [emailBackgroundColor, setEmailBackgroundColor] = useState('#ffffff')
  const [emailAnimationNumberOfMoves, setEmailAnimationNumberOfMoves] = useState(3)
  const [emailMode, setEmailMode] = useState('static') //emailMode can be: 'custom', 'static' or 'animated'
  const [emailCustomImage, setEmailCustomImage] = useState('')
  //const [emailStaticImage, setEmailStaticImage] = useState('') //not really used here but this variable is needed to preserve the value of this image during the onChange events

  //const TILE_SIZE = useMemo(() => canvasSize / gridSize, [canvasSize, gridSize]);
  const TILE_WIDTH = useMemo(() => canvasWidth / gridSize, [canvasWidth, gridSize]);
  const TILE_HEIGHT = useMemo(() => canvasHeight / gridSize, [canvasHeight, gridSize]);

  const EMPTY = gridSize * gridSize - 1;
  
  const [noRender, setNoRender] = useState(false)

  
    useImperativeHandle(ref, () => ({
    async askFrames() {
      setNoRender(true)
      const result = animateClicks(true)
      return result;
    },
    askImage() {
      setNoRender(true)
      const result = getCanvasImage()
      return result;
    },
  }))




  // Load image
useEffect(() => {
  if (!props.imageDataUrl) return;

  const originalImage = new window.Image();
  originalImage.src = props.imageDataUrl;
  originalImage.onload = () => {
    // Auto-set canvas size on first image load
    /*
    if (!hasAutoSized.current) {
      const autoSize = originalImage.width;
      setCanvasSize(autoSize);
      hasAutoSized.current = true;
    }
    */

   //if (props.settings && props.settings.canvasSize === undefined) setCanvasSize(originalImage.width)


    // Resize image to current canvas size
    const offCanvas = document.createElement('canvas');
    offCanvas.width = canvasWidth;
    offCanvas.height = canvasHeight;
    const ctx = offCanvas.getContext('2d');
    ctx.drawImage(originalImage, 0, 0, offCanvas.width, offCanvas.height);

    const resizedDataUrl = offCanvas.toDataURL();
    const resizedImage = new window.Image();
    resizedImage.src = resizedDataUrl;
    resizedImage.onload = () => setImage(resizedImage);
  };
}, [props.imageDataUrl, canvasWidth, canvasHeight]);


const hasInitializedTiles = useRef(false);

useEffect(() => {
  if (hasInitializedTiles.current) return;
  console.log(props.settings)

  if (props.settings && props.settings.tiles) {
    setTiles(props.settings.tiles);
    setGridSize(props.settings.gridSize)
  } else {
    const arr = [...Array(gridSize * gridSize).keys()];
    shuffleSolvable(arr);
    setTiles(arr);
  }

  if (props.settings && props.settings.emailBackgroundColor) setEmailBackgroundColor(props.settings.emailBackgroundColor)
  //if (props.settings && props.settings.canvasSize) setCanvasSize(props.settings.canvasSize)
  if (props.settings && props.settings.canvasWidth) setCanvasWidth(props.settings.canvasWidth)
  if (props.settings && props.settings.canvasHeight) setCanvasHeight(props.settings.canvasHeight)
  if (props.settings && props.settings.emailAnimationNumberOfMoves) setEmailAnimationNumberOfMoves(props.settings.emailAnimationNumberOfMoves)
  if (props.settings && props.settings.emailMode) setEmailMode(props.settings.emailMode)
  if (props.settings && props.settings.emailCustomImage) setEmailCustomImage(props.settings.emailCustomImage)
  //if (props.settings && props.settings.emailStaticImage) setEmailStaticImage(props.settings.emailStaticImage)

  hasInitializedTiles.current = true;
}, [props.settings]);



useEffect(() => {
    handlePuzzleSettingsChange('tiles', tiles)
  tilesRef.current = [...tiles];
}, [tiles]);


  const handlePuzzleSettingsChange = (propName, propValue) => {
    const settings = {gridSize: gridSize, tiles: tiles, canvasWidth: canvasWidth, canvasHeight: canvasHeight, emailBackgroundColor: emailBackgroundColor,
       emailAnimationNumberOfMoves: emailAnimationNumberOfMoves, emailMode: emailMode
      ,emailCustomImage: emailCustomImage, }

    settings[propName] = propValue
    //console.log(settings)
    if (props.onPuzzleSettingsChange) props.onPuzzleSettingsChange(settings)
  }
  const handlePuzzleSettingsChangeMulti = (values) => {
    //values is an array of array: [[propName1, propValue1], [propName2, propValue2], ]
    const settings = {gridSize: gridSize, tiles: tiles, canvasWidth: canvasWidth, canvasHeight: canvasHeight, emailBackgroundColor: emailBackgroundColor,
       emailAnimationNumberOfMoves: emailAnimationNumberOfMoves, emailMode: emailMode
      ,emailCustomImage: emailCustomImage, }

    for (const [propName, propValue] of values) {
      settings[propName] = propValue
    }
    //console.log(settings)
    if (props.onPuzzleSettingsChange) props.onPuzzleSettingsChange(settings)
  }


  const shuffleSolvable = (array) => {
    do {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
    } while (!isSolvable(array));
  };

const isSolvable = (tiles) => {
  const size = Math.sqrt(tiles.length);
  const inversions = tiles.reduce((inv, curr, i) => {
    if (curr === EMPTY) return inv;
    for (let j = i + 1; j < tiles.length; j++) {
      if (tiles[j] !== EMPTY && tiles[i] > tiles[j]) inv++;
    }
    return inv;
  }, 0);

  const blankIndex = tiles.indexOf(EMPTY);
  const rowFromBottom = size - Math.floor(blankIndex / size);
  //console.log(JSON.stringify(tiles))

  if (size % 2 === 1) {
    // odd grid
    return inversions % 2 === 0;
  } else {
      if (rowFromBottom % 2 === 0) return inversions % 2 !== 0
      else return inversions % 2 === 0
  }
};


  const resetPuzzle = (tilePos) => {
    //console.log(tilePos)
    if (tilePos) {
      setTiles(tilePos);
      tileRefs.current = {};
      setAnimating(false);
    }
    else {
      const count = gridSize * gridSize;
      const arr = [...Array(count).keys()];
      shuffleSolvable(arr);
      setTiles(arr);
      tileRefs.current = {};
      setAnimating(false);
    }
  };

  const isAdjacent = (i1, i2) => {
    const row1 = Math.floor(i1 / gridSize), col1 = i1 % gridSize;
    const row2 = Math.floor(i2 / gridSize), col2 = i2 % gridSize;
    return (Math.abs(row1 - row2) + Math.abs(col1 - col2)) === 1;
  };

  const handleTileClick = (index) => {
    if (animating) return;

    const emptyIndex = tiles.indexOf(EMPTY);
    if (!isAdjacent(index, emptyIndex)) return;

    setAnimating(true);
    const clickedTile = tiles[index];

    const toX = (emptyIndex % gridSize) * TILE_WIDTH;
    const toY = Math.floor(emptyIndex / gridSize) * TILE_HEIGHT;

    const tileNode = tileRefs.current[clickedTile];
    if (tileNode) {
      tileNode.to({
        x: toX,
        y: toY,
        duration: 0.2,
        onFinish: () => {
          const newTiles = [...tiles];
          [newTiles[index], newTiles[emptyIndex]] = [newTiles[emptyIndex], newTiles[index]];
          setTiles(newTiles);
          //console.log(JSON.stringify(newTiles))
          //console.log(newTiles)
          setAnimating(false);
          if (newTiles.every((val, i) => val === i)) alert('🎉 Puzzle Solved!');
        }
      });
    }
  };

const handleTileSequence = async (indexes, captureFrames = false) => {
  if (animating || indexes.length === 0) return;

  setAnimating(true);

  let currentTiles = [...tiles];
  let currentEmptyIndex = currentTiles.indexOf(EMPTY);
  const frames = [];

  if (captureFrames) {
    const frame = stageRef.current.toDataURL();
    frames.push(frame)
  }

  for (const index of indexes) {
    if (!isAdjacent(index, currentEmptyIndex)) continue;

    const tileNum = currentTiles[index];
    const tileNode = tileRefs.current[tileNum];
    const toX = (currentEmptyIndex % gridSize) * TILE_WIDTH;
    const toY = Math.floor(currentEmptyIndex / gridSize) * TILE_HEIGHT;

    if (!tileNode) continue;

    await new Promise((resolve) => {
      const duration = 0.3; // seconds
      const start = performance.now();
      let midpointCaptured = false;

      tileNode.to({
        x: toX,
        y: toY,
        duration,
        onUpdate: () => {
          if (!captureFrames || midpointCaptured || !stageRef.current) return;

          const elapsed = (performance.now() - start) / 1000;
          if (elapsed >= duration / 2) {
            const frame = stageRef.current.toDataURL();
            frames.push(frame);
            midpointCaptured = true;
          }
        },
        onFinish: () => {
          if (captureFrames && stageRef.current) {
            const frame = stageRef.current.toDataURL();
            frames.push(frame);
          }
          resolve();
        },
      });
    });

    // Logic swap
    [currentTiles[index], currentTiles[currentEmptyIndex]] = [currentTiles[currentEmptyIndex], currentTiles[index]];
    currentEmptyIndex = index;
  }

  setTiles(currentTiles);
  setAnimating(false);

  if (currentTiles.every((val, i) => val === i)) {
    alert('🎉 Puzzle Solved!');
  }

  return captureFrames ? frames : undefined;
};


  const handleGridSizeChange = (val) => {
    //const val = parseInt(e.target.value);
    //if (!isNaN(val) && val >= 2 && val <= 10) setGridSize(val);
    setGridSize(val)
    const count = val * val;
    const arr = [...Array(count).keys()];
    shuffleSolvable(arr);
    setTiles(arr);

    if (props.onPuzzleSettingsChange) {
      props.onPuzzleSettingsChange({
        gridSize: val,
        tiles: arr,
        canvasWidth,
        canvasHeight,
      });
    }


    //handlePuzzleSettingsChange('gridSize', val)
  };

  const handleCanvasSizeChange = (newWidth, newHeight) => {
    if (canvasKeepRatio) {

      // w / h = nW / nH
      if (newWidth) {
        const h = canvasHeight * newWidth / canvasWidth
        setCanvasWidth(newWidth)
        setCanvasHeight(h)
        handlePuzzleSettingsChangeMulti([['canvasWidth', newWidth],['canvasHeight', h]])
      }
      if (newHeight) {
        const w = canvasWidth * newHeight / canvasHeight
        setCanvasHeight(newHeight)
        setCanvasWidth(w)
        handlePuzzleSettingsChangeMulti([['canvasWidth', w],['canvasHeight', newHeight]])
      }

    }
    else {
      if (newWidth) {
        setCanvasWidth(newWidth)
        handlePuzzleSettingsChange('canvasWidth', newWidth)
      }
      if (newHeight) {
        setCanvasHeight(newHeight)
        handlePuzzleSettingsChange('canvasHeight', newHeight)
      }
    }
  };


const handleChangeSnippetSettings = (propName, propValue) => {
  //const newSettings = {...snippetSettings, [propName]: propValue}

  //setSnippetSettings(newSettings)
}

const animateClicks = async (captureFrames = false) => {
  const tileOrder = tilesRef.current.slice(); // clone for virtual simulation
  let emptyIndex = tileOrder.indexOf(EMPTY);
  let previousIndex = -1;
  const path = [];

  for (let i = 0; i < emailAnimationNumberOfMoves; i++) {
    const row = Math.floor(emptyIndex / gridSize);
    const col = emptyIndex % gridSize;

    const neighbors = [];
    if (col > 0) neighbors.push(emptyIndex - 1);
    if (col < gridSize - 1) neighbors.push(emptyIndex + 1);
    if (row > 0) neighbors.push(emptyIndex - gridSize);
    if (row < gridSize - 1) neighbors.push(emptyIndex + gridSize);

    const validMoves = neighbors.filter((idx) => idx !== previousIndex);
    if (validMoves.length === 0) break;

    const nextIndex = validMoves[Math.floor(Math.random() * validMoves.length)];
    path.push(nextIndex);

    // Simulate move for future path generation
    [tileOrder[emptyIndex], tileOrder[nextIndex]] = [tileOrder[nextIndex], tileOrder[emptyIndex]];
    previousIndex = emptyIndex;
    emptyIndex = nextIndex;
  }

    const frames = await handleTileSequence(path, captureFrames);
    //console.log(frames)
    //console.log(frames.length)
    //downloadDataURLImages(frames)
    return frames

};
const getCanvasImage = () => {
    const result = stageRef.current.toDataURL();
    return result
}


return (<div className={`text-ccColorDarkTeal p-2 flex flex-col gap-y-2 ${noRender ? ' absolute top-[-9999px] left-[-9999px]' : ''}`}>
    <CcSubSectionTitle>What you see in the email</CcSubSectionTitle>
    <div class="flex rounded-md font-poppins" >
      <div className={`cursor-pointer px-4 py-2 w-80 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-s-lg hover:bg-gray-100 hover:text-ccColorTeal ${emailMode === 'custom' ? 'bg-gray-200' : 'bg-white'}`}
            onClick={()=>{setEmailMode('custom'); handlePuzzleSettingsChange('emailMode', 'custom')}}
            >
        <div>
          Custom image
        </div>
        <div className='text-sm mt-2 font-normal'>Display your cover image as a static image. </div>
      </div>
      <div className={`cursor-pointer px-4 py-2 w-80 font-medium border-t border-b border-gray-200 focus:outline-none focus:ring-0 hover:bg-gray-100 hover:text-ccColorTeal ${emailMode === 'static' ? 'bg-gray-200' : 'bg-white'}`}
          onClick={()=>{setEmailMode('static'); handlePuzzleSettingsChange('emailMode', 'static')}}
          >
        <div>
          Puzzle static image
        </div>
        <div className='text-sm mt-2 font-normal'>Create an animated gif which partially reveals your background image.</div>
      </div>
      <div className={`cursor-pointer px-4 py-2 w-80 font-medium border border-gray-200 focus:outline-none focus:ring-0 rounded-e-lg hover:bg-gray-100 hover:text-ccColorTeal ${emailMode === 'dynamic' ? 'bg-gray-200' : 'bg-white'}`}
          onClick={()=>{setEmailMode('dynamic'); handlePuzzleSettingsChange('emailMode', 'dynamic')}}
          >
        <div>
          Puzzle animated image
        </div>
        <div className='text-sm mt-2 font-normal'>Create an animated gif with a pointer to tease the scratch off effect.</div>
      </div>
    </div>
    {emailMode === 'custom' && <div className='mt-4 flex flex-row items-center gap-x-24'>
          <FileSelector noDeleteButton
            text="Upload your own image"
            onChange={(dataurl) => {setEmailCustomImage(dataurl); handlePuzzleSettingsChange('emailCustomImage', dataurl)}}
            />
        {emailCustomImage && emailCustomImage !== '' &&
          <div className='bg-slate-200 rounded p-4 mt-2 w-[360px] h-[360px] flex justify-center'>
            <div className='relative h-full' >

                <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${emailCustomImage}`} />

            </div>
          </div>
        }
        {(emailCustomImage === '') && getErrorMessage(props.validationErrorsList, 'emailCustomImage') && getErrorMessage(props.validationErrorsList, 'emailCustomImage').length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1'>
          <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />

          {getErrorMessage(props.validationErrorsList, 'emailCustomImage')}
          </div>
        }

      </div>
    }

    {emailMode !== 'custom' && <div className='grid grid-cols-3'>
        <div className='flex flex-col gap-y-2'>
          <div className='text-ccColorDarkTeal font-poppins font-semibold'>Settings</div>
          <div className='w-36'>
            <label  className="block text-sm font-medium leading-6 text-gray-900">
            Grid size
            </label>
            <LionListbox items={[{id: 3, name: <div className='flex flex-row gap-x-2 items-center'><GridIcon size={3} cellSize={6} className=" text-[#357e86]" /><div className='text-base'>3x3</div></div>},
                                {id: 4, name: <div className='flex flex-row gap-x-2 items-center'><GridIcon size={4} cellSize={6} className=" text-[#357e86]" /><div className='text-base'>4x4</div></div>}]}
                selectedItemId={gridSize}
                onChange={(item) => handleGridSizeChange(item.id)}
                zIndex={1}
              />
          </div>

          <div className='flex flex-row gap-x-4 items-center'>
            <div className='w-[180px]'>
              <InputNumber
                  displayName="Canvas width"
                  min={100}
                  value={canvasWidth}
                  onChange={(val) => handleCanvasSizeChange(val)}
                  incr={5}
                  suffix="px"
                    />
            </div>
            <div className='w-[180px]'>
              <InputNumber
                  displayName="Canvas height"
                  min={100}
                  value={canvasHeight}
                  onChange={(val) => handleCanvasSizeChange(undefined, val)}
                  incr={5}
                  suffix="px"
                    />
            </div>
            <div className='mt-6'>
              <LockToggleButton onClick={setCanvasKeepRatio} />
            </div>
          </div>

            <div className='mt-2 flex flex-row gap-x-2 items-center'>
              <CcActionButtonOutlined onClick={() => resetPuzzle()}><div className='w-40 text-center'>Shuffle</div></CcActionButtonOutlined>
              <InfoToolTip 
                  placement="top"
                  headLine='Shuffling'
                  message="You can keep randomly shuffling until you see an image that you like to use as the static puzzle image in your email"
              />
            </div>

            <div className='flex flex-col gap-x-2'>
              <div className="block text-sm font-medium leading-6 text-gray-900">Background colour</div>
              <LionColorPicker color={emailBackgroundColor}
                  onChange={(color) => {setEmailBackgroundColor(color); handlePuzzleSettingsChange('emailBackgroundColor', color)}}
                  //onSelected={(color) => handleEditPathStyle(index, 'fill', color)}
              />
            </div>
            {emailMode === 'dynamic' && <div className='border rounded text-ccColorDarkTeal p-1'>
              <div className='font-semibold'>Animation</div>
              <div className='w-[200px] mt-2 mb-4'>
                <InputNumber
                    displayName="Number of moves"
                    min={2} max={10}
                    value={emailAnimationNumberOfMoves}
                    onChange={(num) => {setEmailAnimationNumberOfMoves(num); handlePuzzleSettingsChange('emailAnimationNumberOfMoves', num)}}
                      />
              </div>


                <CcActionButtonOutlined onClick={() => animateClicks()}><div className='w-40 text-center'>Play</div></CcActionButtonOutlined>
              </div>
            }

        </div>

        <div className='col-span-2 flex flex-col items-center'>
          <div className='text-ccColorDarkTeal font-poppins font-semibold'>Preview</div>
          <Stage width={canvasWidth} height={canvasHeight} ref={stageRef}>
            <Layer>
              <Rect
                x={0}
                y={0}
                width={canvasWidth}
                height={canvasHeight}
                fill={emailBackgroundColor}
                listening={false} // makes it non-interactive
              />

              {image &&
                tiles.map((tileNum, index) => {
                  if (tileNum === EMPTY) return null;

                  const currentX = (index % gridSize) * TILE_WIDTH;
                  const currentY = Math.floor(index / gridSize) * TILE_HEIGHT;

                  const sx = (tileNum % gridSize) * TILE_WIDTH;
                  const sy = Math.floor(tileNum / gridSize) * TILE_HEIGHT;

                  return (
                    <KonvaImage
                      key={tileNum}
                      x={currentX}
                      y={currentY}
                      width={TILE_WIDTH}
                      height={TILE_HEIGHT}
                      image={image}
                      crop={{
                        x: sx,
                        y: sy,
                        width: TILE_WIDTH,
                        height: TILE_HEIGHT
                      }}
                      ref={(node) => (tileRefs.current[tileNum] = node)}
                      onPointerDown={() => handleTileClick(index)}
                      //cornerRadius={6}
                    />
                  );
                })}
            </Layer>
          </Stage>
        </div>
      </div>
    }


    </div>
  );
})


export function SlidingPuzzleElementAssetsManager(props) {
  /*
  props:
  templateId: (must be provided for new )
  snippetInfo: (must be provided for edits )

  onChange: returns all the snippet info
  */

  const {settings, setSettings} = useContext(SettingsContext);

  const [snippetName, setSnippetName] = useState('')
  const [snippetDesc, setSnippetDesc] = useState('')
  const [snippetSettings, setSnippetSettings] = useState({teaserImgB64: '', revealImages: [{imgB64: '', href:''}]})


  const [generatingTeaser, setGeneratingTeaser] = useState(false)

  useEffect(() => {
    if (props.snippetInfo) { //we are in edit
      //console.log(props.snippetInfo)
      setSnippetName(props.snippetInfo.snippetName)
      setSnippetDesc(props.snippetInfo.snippetDesc)
      setSnippetSettings(props.snippetInfo.snippetSettings)
    }
    else {
      
    }

  }, [props.templateId, props.snippetInfo, settings])


  const prepareDataToPost = (updatePropName, updatePropValue) => {
    const result = {snippetId: 0, snippetName: '', snippetDesc: '', 
    labels: [{labelId: 0, labelName: ''}], href: '',
    snippetTypeId: 20,
    filters: [], orderBy: [],
    dataConnectionId: 0, templateId: 0, dataConnectionInfo: {}};

    result.snippetName = snippetName;
    result.snippetDesc = snippetDesc;
    result.snippetSettings = snippetSettings;
    result.webPageSettings = props.snippetInfo.webPageSettings;

    if (updatePropName) {
      result[updatePropName] = updatePropValue;
    }
      //console.log(result)
      return result;
  }

  const handleSnippetNameChange = (newValue) => {
    setSnippetName(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetName', newValue))
  }
  const handleSnippetDescChange = (newValue) => {
    setSnippetDesc(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetDesc', newValue))
  }

  const handleImageChange = async (dataURL) => {
    let imgB64 = ''
    
    //const imgSize = await getImageSize(dataURL)
    imgB64 = dataURL;
    
    const newSnippetSettings = {...snippetSettings, puzzleImgB64: imgB64 }
    setSnippetSettings(newSnippetSettings)
    //setOriginalTeaserImgB64(imgB64)
    if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSnippetSettings))

  }
/*
const getImageSize = (dataURL) => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };

    img.onerror = (err) => {
      reject(new Error("Failed to load image"));
    };

    img.src = dataURL;
  });
}
*/


  return <div className='text-ccColorDarkTeal p-2 flex flex-col'>
    <div className='flex flex-row gap-x-4'>
      <div className="w-96">
        <InputText
                displayName="Name"
                value={snippetName}
                onChange={(val) => {handleSnippetNameChange(val);}}
                error={getErrorMessage(props.validationErrorsList, 'snippetName')}
        />
      </div>

      <div className="w-96">
        <InputText
                  displayName="Description"
                  value={snippetDesc}
                  onChange={(val) => {handleSnippetDescChange(val);}}
                  error={getErrorMessage(props.validationErrorsList, 'snippetDesc')}
        />
      </div>
    </div>
  
      <div className='mt-4 border rounded p-2 h-[400px] flex flex-row items-center gap-x-32'>
        <div className='flex flex-row gap-x-1 items-center'>
            <FileSelector noDeleteButton
            text="Upload puzzle image"
            onChange={handleImageChange}
            //base64={props.action ? props.action.imgB64 : undefined}
            />
            <InfoToolTip 
                placement="top"
                headLine='Puzzle Image'
                message="For best results please upload a square image"
            />
        </div>
        {snippetSettings.puzzleImgB64 === '' && <div className='bg-slate-200 rounded p-4 mt-2 w-[400px] h-[300px] flex flex-col justify-center items-center'>
              <Iconify icon="carbon:no-image" width={200} />
              <div className='font-poppins font-semibold'>No image uploaded</div>
          </div>

        }
        {generatingTeaser &&
          <div className='mt-4 flex justify-center'><CcLoader size={96} /></div>
        }
        {snippetSettings.puzzleImgB64 !== '' && !generatingTeaser &&
          <div className='bg-slate-200 rounded p-4 mt-2 w-[360px] h-[360px] flex justify-center'>
            <div className='relative h-full' >

                <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${snippetSettings.puzzleImgB64}`} />
                {/*<img className='max-w-none' src={`data:image;base64,${snippetSettings.teaserImgB64}`} />*/}


            </div>
          </div>
        }
        {getErrorMessage(props.validationErrorsList, 'snippetSettingsPuzzleImg') && getErrorMessage(props.validationErrorsList, 'snippetSettingsPuzzleImg').length > 0 && <div className='flex flex-row items-center text-red-500 gap-x-1'>
          <ExclamationCircleIcon className="h-5 w-5" aria-hidden="true" />

          <div className='max-w-[400px]'>{getErrorMessage(props.validationErrorsList, 'snippetSettingsPuzzleImg')}</div>
          </div>
        }

      </div>

    </div>

}

export const SlidingPuzzleElementWebPageManager = forwardRef((props, ref) => {

  const [templates, setTemplates] = useState([])
  const [selectedTemplateId, setSelectedTemplateId] = useState(0)
  const [templatePropValuesCollection, setTemplatePropValuesCollection] = useState([]) //[{propName: '', propValue: ''}]
  const [fonts, setFonts] = useState([])
  const [coverType, setCoverType] = useState('solidColor') //can be: 'solidColor', 'useEmailCover', 'image' 
  const [coverSolidColor, setCoverSolidColor] = useState('#b3b3b3')
  const [puzzleBgColor, setPuzzleBgColor] = useState('#ffffff')
  const [puzzleAfterImage, setPuzzleAfterImage] = useState('')
  const [timeZones, setTimeZones] = useState(undefined);
  const [href, setHref] = useState('');

  const svgSelectorRef = useRef();


  useEffect(() => {
    if (props.snippetInfo) {

      if (props.snippetInfo.webPageSettings) {
        //console.log(props.snippetInfo.webPageSettings)
        setSelectedTemplateId(props.snippetInfo.webPageSettings.selectedWebPageId)
        setTemplatePropValuesCollection(props.snippetInfo.webPageSettings.templatePropValuesCollection)
        setCoverType(props.snippetInfo.webPageSettings.coverType)
        setCoverSolidColor(props.snippetInfo.webPageSettings.coverSolidColor)
        setPuzzleBgColor(props.snippetInfo.webPageSettings.puzzleBgColor)
        setPuzzleAfterImage(props.snippetInfo.webPageSettings.puzzleAfterImage)
        //setCoverAddEffect(props.snippetInfo.webPageSettings.coverAddEffect)
        setHref(props.snippetInfo.webPageSettings.href)
      }
      else {

      }
    }
    if (templates.length === 0) {
      let initialTemplateId = 3
      if (props.snippetInfo && props.snippetInfo.webPageSettings) initialTemplateId = props.snippetInfo.webPageSettings.selectedWebPageId
      getTemplates(initialTemplateId);
    }
    if (fonts.length === 0) getFonts();
  
  }, [props.snippetInfo])

  useEffect(() => {
    getTimezones()
  }, [])

  const getTemplates = async (initialTemplateId) => {
    try {
      let url = `${process.env.REACT_APP_LION_API_URL}/WebPages/Templates/20`;

      const response = await axios.get(url);
      setTemplates(response.data);
      setSelectedTemplateId(initialTemplateId)
      if (props.snippetInfo.webPageSettings.templatePropValuesCollection.length === 0) initTemplatePropValuesCollection(initialTemplateId, response.data)
      
    } catch (error) {
      //console.log(error);
    }

  }
  const getFonts = async () => {
    try {
      let url = `${process.env.REACT_APP_LION_API_URL}/WebPages/GoogleFontsList`;

      const response = await axios.get(url);
      setFonts(response.data);
      
    } catch (error) {
      //console.log(error);
    }

  }
  const doOnChange = (templateId, values) => {
    if (props.onChange) {
      const result = {selectedWebPageId: templateId, templatePropValuesCollection: values, coverType: coverType, coverSolidColor: coverSolidColor,
                     coverAddEffect: props.snippetInfo.webPageSettings.coverAddEffect, confettiAddEffect: props.snippetInfo.webPageSettings.confettiAddEffect,
                     confettiColors: props.snippetInfo.webPageSettings.confettiColors,
                     href: href, puzzleBgColor: puzzleBgColor, puzzleAfterImage: puzzleAfterImage,
                     expiryDate: props.snippetInfo.webPageSettings.expiryDate, expiryTimezoneId: props.snippetInfo.webPageSettings.expiryTimezoneId }
      props.onChange(result)
    }
  }
  const doOnChangeWithNewValue = (propName, propValue) => {
    if (props.onChange) {
      const result = {selectedWebPageId: selectedTemplateId, templatePropValuesCollection: templatePropValuesCollection, coverType: coverType, coverSolidColor: coverSolidColor,
                     coverAddEffect: props.snippetInfo.webPageSettings.coverAddEffect, confettiAddEffect: props.snippetInfo.webPageSettings.confettiAddEffect,
                     confettiColors: props.snippetInfo.webPageSettings.confettiColors,
                     href: href, puzzleBgColor: puzzleBgColor, puzzleAfterImage: puzzleAfterImage,
                      expiryDate: props.snippetInfo.webPageSettings.expiryDate, expiryTimezoneId: props.snippetInfo.webPageSettings.expiryTimezoneId}
      result[propName] = propValue;
      props.onChange(result)
    }
  }

  useImperativeHandle(ref, () => ({
    async askPointerImg() {
      const result =  getPointerImg();
      return result;
    },
  }))

  const getPointerImg = async () => {
    const result = await svgSelectorRef.current.askPointerImg();

    return result;
  }


  const initTemplatePropValuesCollection = (templateId, _templates) => {
    let activeTemplate = undefined;
    if (_templates) activeTemplate = _templates.find(t => t.webPageTemplateId === templateId)
    else activeTemplate = templates.find(t => t.webPageTemplateId === templateId)

    if (_templates !== undefined) {
      const result = []
      activeTemplate.placeHolders.forEach(p => {result.push({propName: p.codeName, propValue: p.defaultValue})})
      result.push({propName: 'brushStrokeWidth',  propValue: '35'})
      result.push({propName: 'timeoutToReveal',  propValue: '1600'})
      doOnChange(templateId, result)
      return result;
    }
    return templatePropValuesCollection;
  }

  const getTemplatePropValue = (propName) => {
    //retrieve the prop value (give its name) from the templatePropValuesCollection
    const matchedProp = templatePropValuesCollection.find(pv => pv.propName === propName);
    
    if (matchedProp && matchedProp.propValue !== '') return matchedProp.propValue;
    else {
      //we try to get the default value if available
      const activeTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId)
      if (activeTemplate === undefined) return ''
      const currentPlaceholder = activeTemplate.placeHolders.find(p => p.codeName === propName)
      if (currentPlaceholder === undefined) return ''
      return currentPlaceholder.defaultValue ?? ''
    }
    
  }
  const setTemplatePropValue = (propName, propValue) => {
    //retrieve the prop value (give its name) from the templatePropValuesCollection
    const matchedIndex = templatePropValuesCollection.findIndex(pv => pv.propName === propName);
    const newValues = [...templatePropValuesCollection];

    //newValues.splice(matchedIndex, 1, {propName: propName, propValue: propValue})
    //setTemplatePropValuesCollection(newValues)
    //console.log(newValues)
    
    if (matchedIndex === -1) {
      newValues.push({propName: propName, propValue: propValue})
      setTemplatePropValuesCollection(newValues)
    }
    else {
      newValues.splice(matchedIndex, 1, {propName: propName, propValue: propValue})
      setTemplatePropValuesCollection(newValues)
    }
    
    doOnChange(selectedTemplateId, newValues)
  }

  const handleTimezoneChange = (timezone) => {
    doOnChangeWithNewValue('expiryTimezoneId', timezone.id)

  }
 
  const handleConfettiColorsChange = (newColors) => {
    doOnChangeWithNewValue('confettiColors', newColors)
  }

  const renderLayoutSettings = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    // we custom render known (and mandatory) placeholders (e.g. {cc-body-bg-color}, {cc-body-bg-image} )
    // then for anything else we do a generic render based on a two-column layout

    const knownPlacerholderIds = ['{cc-body-bg-color}', '{cc-body-bg-image}', '{cc-main-content-bg-color}',
                                  '{cc-logo-image}', '{cc-Main-Content-Title}', '{cc-Main-Content-Title-Font}', '{cc-Main-Content-Title-Size}',
                                  '{cc-Main-Content-Title-Color}', '{cc-puzzle-msg}', '{cc-puzzle-msg-size}', '{cc-puzzle-msg-font}',
                                  '{cc-puzzle-msg-color}', '{cc-post-puzzle-msg}', '{cc-post-puzzle-msg-font}',
                                  '{cc-post-puzzle-msg-size}', '{cc-post-puzzle-msg-color}', '{cc-post-scratch-button-title}',
                                  '{cc-post-scratch-button-title-font}', '{cc-post-scratch-button-title-size}', '{cc-post-scratch-button-title-textcolor}',
                                  '{cc-post-scratch-button-title-bgcolor}', '{cc-expired-msg}', '{cc-webpage-title}', '{cc-cta-border-radius}',
                                  '{cc-expired-button-title}', '{cc-expired-href}'
                                 ]
    //BACKGROUND SECTION
    //{cc-body-bg-color}
    //{cc-body-bg-image}
    //{cc-main-content-bg-color}


    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    //selectedTemplate.placeHolders.forEach(p => console.log(p))

    const remainingPlaceholders = selectedTemplate.placeHolders.filter(obj => !knownPlacerholderIds.includes(obj.placeHolder));
    //remainingPlaceholders.forEach(p => console.log(p))
    
    return remainingPlaceholders.map(prop => <div className='col-span-1'>
              {prop.type === 'text' && 
              <InputText
                displayName={prop.prettyName}
                value={getTemplatePropValue(prop.codeName)}
                onChange={(val) => {setTemplatePropValue(prop.codeName, val);}}
              />
              }
              {prop.type === 'number' && 
                          <div className='w-[200px] mt-4'>
                            <InputNumber
                                displayName={prop.prettyName}
                                value={getTemplatePropValue(prop.codeName)}
                                onChange={(val) => {setTemplatePropValue(prop.codeName, val.toString());}}
                                  />
                          </div>
              }
              {prop.type === 'color' && <div>
                            <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                              {prop.prettyName}
                            </div>
                            <LionColorPicker //color={p.defaultValue}
                              //onChange={(color) => {handleModelChange(p.propName, color)}}
                              color={getTemplatePropValue(prop.codeName)}
                              onChange={(val) => {setTemplatePropValue(prop.codeName, val);}}
                            />

              </div>
              }
              {prop.type === 'image' && <div>
                           <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                              {prop.prettyName}
                            </div>
                            <div className='flex flex-row gap-x-2 items-center'>
                              <FileSelector noDeleteButton
                                text="Upload"
                                onChange={(dataURL) => setTemplatePropValue(prop.codeName, dataURL)}
                              />
                              {getTemplatePropValue(prop.codeName).length === 0 && 
                                <div>Not used</div>
                              }
                              {getTemplatePropValue(prop.codeName).length > 0 && <div className='flex flex-row gap-x-1'>
                                          <div className='bg-slate-200 rounded p-4 mt-2 max-w-[380px] max-h-[230px] flex justify-center'>
                                            <div className='relative flex justify-center' >
                                                <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${getTemplatePropValue(prop.codeName)}`} />                              
                                            </div>
                                          </div>
                                          <IconButton sx={{width: '48px', height: '48px'}}
                                            onClick={() => setTemplatePropValue(prop.codeName, '')}
                                          ><Iconify icon={lionIcons.Icon_Actions_Cancel} /></IconButton>
                                      </div>                          
                              }
                            </div>
                </div>
              }
              {prop.type === 'font' && <div>
                  <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                    {prop.prettyName}
                  </div>
                  <GoogleFontsSelector
                        fonts={fonts}
                        selected={getTemplatePropValue(prop.codeName)}
                        onChange={(val) => {setTemplatePropValue(prop.codeName, val);}}
                  />
              </div>

              }

    </div>)
  }
  const renderBackgroundSettingsSection = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    const pBgColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-body-bg-color}')
    const pBgImg = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-body-bg-image}')
    const pMainContentBgColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-main-content-bg-color}')
    const pLogoImg = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-logo-image}')
    
    return <div className='bg-slate-100 border rounded p-2'>
        <div className='text-lg font-poppins font-bold mb-2'>Background Configuration</div>
        <div className='flex flex-row items-center'>
          <div className='w-[310px]'>
              <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                Background Colour
              </div>
              <LionColorPicker
                color={getTemplatePropValue(pBgColor.codeName)}
                onChange={(val) => {setTemplatePropValue(pBgColor.codeName, val);}}
              />

          </div>

          <div>
              <div className='flex flex-row items-center gap-x-1'>
                <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                  Background image
                  </div>
                <InfoToolTip 
                            placement='right'
                            headLine='Background image'
                            message="We recommend uploading an image with a width of 1920px. This is generally accepted standard for optimal background image size. The height can be variable but for desktop displays 1920 x 1080 pixels is an optimal background image size."
                          />

              </div>
                <div className='flex flex-row gap-x-2 items-center'>
                  <FileSelector noDeleteButton
                    text="Upload"
                    onChange={(dataURL) => setTemplatePropValue(pBgImg.codeName, dataURL)}
                  />
                  {getTemplatePropValue(pBgImg.codeName).length === 0 && 
                    <div>Not used</div>
                  }
                  {getTemplatePropValue(pBgImg.codeName).length > 0 && <div className='flex flex-row gap-x-1'>
                              <div className='bg-slate-200 rounded p-4 mt-2 max-w-[380px] max-h-[230px] flex justify-center'>
                                <div className='relative flex justify-center' >
                                    <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${getTemplatePropValue(pBgImg.codeName)}`} />                              
                                </div>
                              </div>
                              <IconButton sx={{width: '48px', height: '48px'}}
                                onClick={() => setTemplatePropValue(pBgImg.codeName, '')}
                              ><Iconify icon={lionIcons.Icon_Actions_Cancel} /></IconButton>
                          </div>                          
                  }
                </div>
          </div>
    
        </div>

        <div className='flex flex-row items-center mt-4'>
          <div className='w-[310px]'>
            <div className='flex flex-row items-center gap-x-1'>
              <div  className="text-sm font-poppins font-medium leading-6 text-gray-900">
                Main Content Tile background colour
              </div>
              <InfoToolTip 
                    placement='right'
                    headLine='Main Content Tile background colour'
                    message="This is the area that your Scratch off and content will be displayed over. "
                  />
            </div>
              <LionColorPicker
                color={getTemplatePropValue(pMainContentBgColor.codeName)}
                onChange={(val) => {setTemplatePropValue(pMainContentBgColor.codeName, val);}}
              />

          </div>

          <div>
                <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                Logo image
                </div>
                <div className='flex flex-row gap-x-2 items-center'>
                  <FileSelector noDeleteButton
                    text="Upload"
                    onChange={(dataURL) => setTemplatePropValue(pLogoImg.codeName, dataURL)}
                  />
                  {getTemplatePropValue(pLogoImg.codeName).length === 0 && 
                    <div>Not used</div>
                  }
                  {getTemplatePropValue(pLogoImg.codeName).length > 0 && <div className='flex flex-row gap-x-1'>
                              <div className='bg-slate-200 rounded p-4 mt-2 max-w-[380px] max-h-[230px] flex justify-center'>
                                <div className='relative flex justify-center' >
                                    <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${getTemplatePropValue(pLogoImg.codeName)}`} />                              
                                </div>
                              </div>
                              <IconButton sx={{width: '48px', height: '48px'}}
                                onClick={() => setTemplatePropValue(pLogoImg.codeName, '')}
                              ><Iconify icon={lionIcons.Icon_Actions_Cancel} /></IconButton>
                          </div>                          
                  }
                </div>
          </div>

        </div>

        <div className='w-[310px] mt-4'>
            <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              Puzzle Background Colour
            </div>
            <LionColorPicker
              color={puzzleBgColor}
              onChange={(val) => {setPuzzleBgColor(val); doOnChangeWithNewValue('puzzleBgColor', val)}}
            />

        </div>

      </div>
  }
  const renderTextContentSettingsSection = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    const pMainContentTitle = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-Main-Content-Title-Puzzle}')
    const pMainContentTitleFont = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-Main-Content-Title-Font}')
    const pMainContentTitleSize = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-Main-Content-Title-Size}')
    const pMainContentTitleColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-Main-Content-Title-Color}')
    
    return <div className='bg-slate-100 border rounded p-2 mt-4'>
      <div className='text-lg font-poppins font-bold mb-2'>Text Content Configuration</div>

        <div className='flex flex-row items-center gap-x-6'>
          <div className='w-[260px]'>
            <InputText
              displayName={pMainContentTitle.prettyName}
              value={getTemplatePropValue(pMainContentTitle.codeName)}
              onChange={(val) => {setTemplatePropValue(pMainContentTitle.codeName, val);}}
            />

          </div>

          <div>
              <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                {pMainContentTitleFont.prettyName}
              </div>
              <GoogleFontsSelector
                    fonts={fonts}
                    selected={getTemplatePropValue(pMainContentTitleFont.codeName)}
                    onChange={(val) => {setTemplatePropValue(pMainContentTitleFont.codeName, val);}}
              />
          </div>

        </div>

        <div className='flex flex-row items-center gap-x-6'>
          <div className='w-[260px]'>
            <InputNumber
                displayName={pMainContentTitleSize.prettyName}
                value={getTemplatePropValue(pMainContentTitleSize.codeName)}
                onChange={(val) => {setTemplatePropValue(pMainContentTitleSize.codeName, val.toString());}}
                  />
          </div>

          <div>
            <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              {pMainContentTitleColor.prettyName}
            </div>
            <LionColorPicker
              color={getTemplatePropValue(pMainContentTitleColor.codeName)}
              onChange={(val) => {setTemplatePropValue(pMainContentTitleColor.codeName, val);}}
            />

          </div>

        </div>
      </div>
  }
  const renderBodyContentSettingsSection = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    const pScratchToRevealMsg = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-puzzle-msg}')
    const pScratchToRevealMsgFont = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-puzzle-msg-font}')
    const pScratchToRevealMsgSize = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-puzzle-msg-size}')
    const pScratchToRevealMsgColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-puzzle-msg-color}')

    const pPostScratchToRevealMsg = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-puzzle-msg}')
    const pPostScratchToRevealMsgFont = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-puzzle-msg-font}')
    const pPostScratchToRevealMsgSize = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-puzzle-msg-size}')
    const pPostScratchToRevealMsgColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-puzzle-msg-color}')
    
    return <div className='bg-slate-100 border rounded p-2 mt-4'>
      <div className='text-lg font-poppins font-bold mb-2'>Body Content Configuration</div>

      <div className='flex flex-row items-center gap-x-6'>
          <div className='w-[260px]'>
            <InputText
                displayName={<div className='flex flex-row items-center gap-x-1'><div>{pScratchToRevealMsg.prettyName}</div>
                  <InfoToolTip 
                      placement='right'
                      headLine={pScratchToRevealMsg.prettyName}
                      message="This is the supporting content you wish to display before the scratch off is revealed. This message will be swapped once the content has been revealed."
                  />
              </div>}
              value={getTemplatePropValue(pScratchToRevealMsg.codeName)}
              onChange={(val) => {setTemplatePropValue(pScratchToRevealMsg.codeName, val);}}
            />

          </div>


          <div>
              <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                {pScratchToRevealMsgFont.prettyName}
              </div>
              <GoogleFontsSelector
                    fonts={fonts}
                    selected={getTemplatePropValue(pScratchToRevealMsgFont.codeName)}
                    onChange={(val) => {setTemplatePropValue(pScratchToRevealMsgFont.codeName, val);}}
              />
          </div>

        </div>

        <div className='flex flex-row items-center gap-x-6'>
          <div className='w-[260px]'>
            <InputNumber
                displayName={pScratchToRevealMsgSize.prettyName}
                value={getTemplatePropValue(pScratchToRevealMsgSize.codeName)}
                onChange={(val) => {setTemplatePropValue(pScratchToRevealMsgSize.codeName, val.toString());}}
                  />
          </div>

          <div>
            <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              {pScratchToRevealMsgColor.prettyName}
            </div>
            <LionColorPicker
              color={getTemplatePropValue(pScratchToRevealMsgColor.codeName)}
              onChange={(val) => {setTemplatePropValue(pScratchToRevealMsgColor.codeName, val);}}
            />

          </div>

        </div>

        <div className='flex flex-row items-center gap-x-6 mt-4'>
          <div className='w-[260px]'>
            <InputText
                displayName={<div className='flex flex-row items-center gap-x-1'><div>{pPostScratchToRevealMsg.prettyName}</div>
                  <InfoToolTip 
                      placement='right'
                      headLine={pPostScratchToRevealMsg.prettyName}
                      message="This is the content you wish to display once the scratch off has been successfully completed."
                  />
              </div>}
              value={getTemplatePropValue(pPostScratchToRevealMsg.codeName)}
              onChange={(val) => {setTemplatePropValue(pPostScratchToRevealMsg.codeName, val);}}
            />

          </div>


          <div>
              <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                {pPostScratchToRevealMsgFont.prettyName}
              </div>
              <GoogleFontsSelector
                    fonts={fonts}
                    selected={getTemplatePropValue(pPostScratchToRevealMsgFont.codeName)}
                    onChange={(val) => {setTemplatePropValue(pPostScratchToRevealMsgFont.codeName, val);}}
              />
          </div>

        </div>

        <div className='flex flex-row items-center gap-x-6'>
          <div className='w-[260px]'>
            <InputNumber
                displayName={pPostScratchToRevealMsgSize.prettyName}
                value={getTemplatePropValue(pPostScratchToRevealMsgSize.codeName)}
                onChange={(val) => {setTemplatePropValue(pPostScratchToRevealMsgSize.codeName, val.toString());}}
                  />
          </div>

          <div>
            <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              {pPostScratchToRevealMsgColor.prettyName}
            </div>
            <LionColorPicker
              color={getTemplatePropValue(pPostScratchToRevealMsgColor.codeName)}
              onChange={(val) => {setTemplatePropValue(pPostScratchToRevealMsgColor.codeName, val);}}
            />

          </div>

        </div>

      </div>
  }
  const renderCallToActionSettingsSection = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    const pPostScratchBtnTitle = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-scratch-button-title}')
    const pPostScratchBtnTitleFont = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-scratch-button-title-font}')
    const pPostScratchBtnTitleSize = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-scratch-button-title-size}')
    const pPostScratchBtnTitleColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-scratch-button-title-textcolor}')
    const pPostScratchBtnTitleBgColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-post-scratch-button-title-bgcolor}')
    const pPostScratchBtnCorners = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-cta-border-radius}')
    
    return <div className='bg-slate-100 border rounded p-2 mt-4'>
      <div className='text-lg font-poppins font-bold mb-2'>Call To action Configuration</div>

        <div className='flex flex-row items-center gap-x-6'>
          <div className='w-[260px]'>
            <InputText
              displayName={pPostScratchBtnTitle.prettyName}
              value={getTemplatePropValue(pPostScratchBtnTitle.codeName)}
              onChange={(val) => {setTemplatePropValue(pPostScratchBtnTitle.codeName, val);}}
            />

          </div>

          <div>
              <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                {pPostScratchBtnTitleFont.prettyName}
              </div>
              <GoogleFontsSelector
                    fonts={fonts}
                    selected={getTemplatePropValue(pPostScratchBtnTitleFont.codeName)}
                    onChange={(val) => {setTemplatePropValue(pPostScratchBtnTitleFont.codeName, val);}}
              />
          </div>

        </div>

        <div className='flex flex-row items-center gap-x-6'>
          <div className='w-[260px]'>
            <InputNumber
                displayName={pPostScratchBtnTitleSize.prettyName}
                value={getTemplatePropValue(pPostScratchBtnTitleSize.codeName)}
                onChange={(val) => {setTemplatePropValue(pPostScratchBtnTitleSize.codeName, val.toString());}}
                  />
          </div>

          <div>
            <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              {pPostScratchBtnTitleColor.prettyName}
            </div>
            <LionColorPicker
              color={getTemplatePropValue(pPostScratchBtnTitleColor.codeName)}
              onChange={(val) => {setTemplatePropValue(pPostScratchBtnTitleColor.codeName, val);}}
            />

          </div>

          <div>
            <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              {pPostScratchBtnTitleBgColor.prettyName}
            </div>
            <LionColorPicker
              color={getTemplatePropValue(pPostScratchBtnTitleBgColor.codeName)}
              onChange={(val) => {setTemplatePropValue(pPostScratchBtnTitleBgColor.codeName, val);}}
            />

          </div>

        </div>

        <div className='mt-3'>
          <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
              Button corners
          </div>
          <div className='flex flex-row gap-x-4 cursor-pointer -mt-2'>
            <div className='flex flex-row items-center -ml-3' onClick={() => {setTemplatePropValue(pPostScratchBtnCorners.codeName, 'rounded')}}>
              <Radio
                checked={getTemplatePropValue(pPostScratchBtnCorners.codeName) === 'rounded'}
                onChange={() => setTemplatePropValue(pPostScratchBtnCorners.codeName, 'rounded')}
                name="radio-coverType"
                inputProps={{ 'aria-label': 'A' }}
                sx={{
                  '&.Mui-checked': {
                    color: ccColorTeal,
                  },
                }}
              />
              <div>Rounded corners</div>
            </div>
            <div className='flex flex-row items-center' onClick={() => {setTemplatePropValue(pPostScratchBtnCorners.codeName, 'square')}}>
              <Radio
                checked={getTemplatePropValue(pPostScratchBtnCorners.codeName) === 'square'}
                onChange={() => setTemplatePropValue(pPostScratchBtnCorners.codeName, 'square')}
                name="radio-coverType"
                inputProps={{ 'aria-label': 'A' }}
                sx={{
                  '&.Mui-checked': {
                    color: ccColorTeal,
                  },
                }}
              />
              <div>Square corners</div>
            </div>
          </div>
        </div>


        <div>
        <div className="w-[450px] font-roboto mt-4">
            <div className='flex flex-row items-center gap-x-1'>
              <label htmlFor="Endpoint" className="block text-sm font-medium text-ccColorDarkTeal font-poppins">
                Button HREF
              </label>
              <InfoToolTip 
                  placement='right'
                  headLine='Button HREF'
                  message="Insert the URL that you wish to direct participants to. This link should include any discount population parameters and tracking that you wish to carry forward."
              />
            </div>

            <InputURL
              //displayName="Name"
              value={href}
              onChange={(val) => {doOnChangeWithNewValue("href", val)}}
              error={getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsRevealHref', 0)}
              />
          </div>

      </div>
      


      </div>
  }
  const renderExpirySettingsSection = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    const pExpiredMsg = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-expired-msg}')
    const pExpiredBtnText = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-expired-button-title}')
    const pExpiredBtnHref = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-expired-href}')
    
    return <div className='bg-slate-100 border rounded p-2 mt-4'>
      <div className='text-lg font-poppins font-bold mb-2'>Expiry Configuration</div>

        <div className='flex flex-row items-center gap-x-6'>
            <div className='w-[260px]'>
              <InputText
                displayName={pExpiredMsg.prettyName}
                value={getTemplatePropValue(pExpiredMsg.codeName)}
                onChange={(val) => {setTemplatePropValue(pExpiredMsg.codeName, val);}}
              />

            </div>

            <div className='flex flex-row items-center gap-x-4'>
          <div>
          <label htmlFor="timerDate" className="block text-sm font-medium leading-6 text-gray-900">
            Date
          </label>
          <div className="mt-1">
          <DateTimePicker
                value={dayjs(props.snippetInfo.webPageSettings.expiryDate)}
                ampm={false}
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
                onChange={handleTimerDateChange}
              />
          </div>
          </div>        
          <div>
            <label htmlFor="snippetDescription" className="block text-sm font-medium leading-6 text-gray-900">
              Time zone
            </label>
            <div className="mt-1">
              <LionCombo items={timeZones}
                onChange={handleTimezoneChange}
                selectedItemId={props.snippetInfo.webPageSettings.expiryTimezoneId}
                zIndex={100}
              />
            </div>
          </div>

            </div>

        </div>

        <div className='flex flex-row items-center gap-x-6'>
            <div className='w-[260px] mt-4'>
              <InputText
                displayName="Expired button text"
                value={getTemplatePropValue(pExpiredBtnText.codeName)}
                onChange={(val) => {setTemplatePropValue(pExpiredBtnText.codeName, val);}}
              />

            </div>

            <div className="w-[450px] font-roboto mt-4">
            <div className='flex flex-row items-center gap-x-1'>
              <label htmlFor="Endpoint" className="block text-sm font-medium text-ccColorDarkTeal font-poppins">
                Expired button HREF
              </label>
              {/*
              <InfoToolTip 
                  placement='right'
                  headLine='Button HREF'
                  message="Insert the URL that you wish to direct participants to. This link should include any discount population parameters and tracking that you wish to carry forward."
              />
               */}
            </div>

            <InputURL
              //displayName="Name"
              value={getTemplatePropValue(pExpiredBtnHref.codeName)}
              onChange={(val) => {setTemplatePropValue(pExpiredBtnHref.codeName, val);}}
              //error={getErrorMessageForArray(props.validationErrorsList, 'snippetSettingsRevealHref', 0)}
              />
          </div>

        </div>

      </div>
  }
  const renderPageMetadataSection = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    const pWebpageTitle = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-webpage-puzzle-title}')
    
    return <div className='bg-slate-100 border rounded p-2 mt-4'>
      <div className='text-lg font-poppins font-bold mb-2'>Page Metadata Configuration</div>

        <div className='w-[260px]'>
            <InputText
              displayName="Title"
              value={getTemplatePropValue(pWebpageTitle.codeName)}
              onChange={(val) => {setTemplatePropValue(pWebpageTitle.codeName, val);}}
            />

        </div>


      </div>
  }

  const renderEffectsSection = () => {
    if (selectedTemplateId === 0) return <></>
    if (templates.length === 0) return <></>

    const selectedTemplate = templates.find(t => t.webPageTemplateId === selectedTemplateId);
    //const pBgColor = selectedTemplate.placeHolders.find(p => p.placeHolder === '{cc-body-bg-color}')
    
    return <div className='bg-slate-100 border rounded p-2 mt-4'>
      <div className='text-lg font-poppins font-bold mb-2'>Effects Configuration</div>

      <div className='flex flex-col items-start'>
        <div className='mt-2'>
          <CcCheckbox
              displayName={<div className='flex flex-row items-center gap-x-1'><div>Add Confetti Effect</div>
                          <InfoToolTip 
                                  placement='right'
                                  headLine='Add Confetti Effect'
                                  message="Upon completing the scratch, confetti will be displayed."
                              />
                          </div>}
            checked={(props.snippetInfo.webPageSettings && props.snippetInfo.webPageSettings.confettiAddEffect) ? props.snippetInfo.webPageSettings.confettiAddEffect : false}
          onChange={(e) => {doOnChangeWithNewValue('confettiAddEffect', e.target.checked);}}
          />
          {props.snippetInfo.webPageSettings && props.snippetInfo.webPageSettings.confettiAddEffect && <div>
            <LionMultiColorPicker colors={props.snippetInfo.webPageSettings.confettiColors}
              onChange={handleConfettiColorsChange}
            />
          </div>          
          }
        </div>


      </div>

        <div className='mt-2'>
            <div className='flex flex-row items-center gap-x-1'>
              <div  className="block text-sm font-poppins font-medium leading-6 text-gray-900">
                After image
                </div>
              <InfoToolTip 
                          placement='right'
                          headLine='After image'
                          message="Optionaly show another image in place of the puzzle once the puzzle is solved. The puzzle will fade out showing this image"
                        />

            </div>
              <div className='flex flex-row gap-x-2 items-center'>
                <FileSelector noDeleteButton
                  text="Upload After image"
                  onChange={(dataURL) => doOnChangeWithNewValue('puzzleAfterImage', dataURL)}
                />
                {puzzleAfterImage && puzzleAfterImage.length > 0 && <div className='flex flex-row gap-x-1'>
                            <div className='bg-slate-200 rounded p-4 mt-2 max-w-[380px] max-h-[230px] flex justify-center'>
                              <div className='relative flex justify-center' >
                                  <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${puzzleAfterImage}`} />                              
                              </div>
                            </div>
                            <IconButton sx={{width: '48px', height: '48px'}}
                              onClick={() => doOnChangeWithNewValue('puzzleAfterImage', '')}
                            ><Iconify icon={lionIcons.Icon_Actions_Cancel} /></IconButton>
                        </div>                          
                }
              </div>
        </div>


      </div>
  }

  

  const getTimezones = async () => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Settings/timezones`;
      const response = await axios.get(url);
      const data = response.data;

      const result = data.map(d => {return {id: d.zoneId, name: d.zoneName}});
      setTimeZones(result);

    } catch (error) {
      //console.log(error);
    }
  }
  const handleTimerDateChange = (newDate) => {
    //newDate.$d.setSeconds(0); //we don't allow to set seconds, for safety we always set them to 0
    //console.log(newDate)
    //console.log(newDate.toJSON())
    doOnChangeWithNewValue('expiryDate', newDate.toJSON())
  }


  return <div className='text-ccColorDarkTeal'>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className='text-lg font-poppins font-bold hidden'>Select a layout</div>
      <div className='grid grid-cols-3 gap-4 h-[160px] overflow-auto hidden'>
        {templates.map(t => <div className={`h-fit p-1 col-span-1 rounded ${selectedTemplateId === t.webPageTemplateId ? 'bg-ccColorLightTeal' :''} hover:bg-ccColorDarkTeal`}> 
            <div className={`relative  p-1 h-32 cursor-pointer  bg-slate-200 rounded flex items-center justify-center `}
              onClick={() => {setSelectedTemplateId(t.webPageTemplateId); /*setTemplatePropValuesCollection(initTemplatePropValuesCollection(t.webPageTemplateId));*/}}
              >
                  <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={t.thumbnailB64} alt='' />    
            </div>
          </div>)
        }
      </div>
      {renderBackgroundSettingsSection()}
      {renderTextContentSettingsSection()}
      {renderBodyContentSettingsSection()}
      {renderEffectsSection()}
      {renderCallToActionSettingsSection()}
      {renderExpirySettingsSection()}
      {renderPageMetadataSection()}

{/* 
    <div className='bg-slate-100 border rounded p-2 mt-6'>
      <div className='text-lg font-poppins font-bold mb-2'>Configure</div>
      <div className='grid grid-cols-2 gap-x-4 gap-y-4'>
        {renderLayoutSettings()}
      </div>
    </div>
*/}

    </LocalizationProvider>
  </div>
})

const WebPagePreviewer = (props) => {
  /*
  props:

  onRequestPointerB64: we need to use this to request the pointer image if coverAddEffect = true
  */
  const [fetchingPreview, setFetchingPreview] = useState(false)
  const [previewHtml, setPreviewHtml] = useState('')


  const getWebPagePreview = () => {
    setOpenPreviewDialog(true)
    setFetchingPreview(true)
    getPreviewHtml()
  }

  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const handleClosePreviewDialog = () => {
    setOpenPreviewDialog(false)
  }

  const getPreviewHtml = async () => {
    setPreviewHtml('')
    try {
      let url = `${process.env.REACT_APP_LION_API_URL}/WebPages/PreviewPuzzle`;
      const dataToPost = {snippetTypeId: 20, webPageTemplateId: props.snippetInfo.webPageSettings.selectedWebPageId,
                           href: ''
                          ,propValuesCollection: props.snippetInfo.webPageSettings.templatePropValuesCollection
                          ,puzzleImgB64: props.snippetInfo.snippetSettings.puzzleImgB64, puzzleBgColor: props.snippetInfo.webPageSettings.puzzleBgColor
                          ,puzzleAfterImage: props.snippetInfo.webPageSettings.puzzleAfterImage
                          ,gridSize: props.snippetInfo.snippetSettings.puzzleSettings.gridSize
                          ,expiryDate: props.snippetInfo.webPageSettings.expiryDate, expiryTimezoneId: props.snippetInfo.webPageSettings.expiryTimezoneId
                          ,confettiAddEffect: props.snippetInfo.webPageSettings.confettiAddEffect, confettiColors: JSON.stringify(props.snippetInfo.webPageSettings.confettiColors) }

      //console.log(props.snippetInfo.snippetSettings)
        
      const response = await axios.post(url, dataToPost);
      //setPreviewHtml(response.data)
      
      const blob = new Blob([response.data], { type: 'text/html' });

      // Generate a URL for the Blob
      const blobUrl = URL.createObjectURL(blob);

      // Open the Blob URL in a new browser tab
      window.open(blobUrl, '_blank');
      
    } catch (error) {
      console.log(error);
    }
    finally {setFetchingPreview(false); handleClosePreviewDialog();}

  }

  return  <div className='flex justify-center'>
  <CcActionButton className="mt-2" type="button" onClick={getWebPagePreview} >Preview web page</CcActionButton>

  <Dialog
        fullWidth
        maxWidth="lg"
        open={openPreviewDialog}
        onClose={handleClosePreviewDialog}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className='p-1 h-[800px] overflow-auto'>
          {fetchingPreview && <div className='flex justify-center mt-48'>
                <CcLoader size={96} />
                </div>
          }
          {!fetchingPreview && <div className=''>
                <iframe className='w-full' srcDoc={previewHtml} sandbox="allow-scripts allow-same-origin" title='Preview'></iframe>
                </div>
          }
          
        </div>
        <DialogActions>
          <CcActionButton className='mr-2 mb-2' onClick={handleClosePreviewDialog}>Close</CcActionButton>
        </DialogActions>
      </Dialog>

</div>

}


export default function SlidingPuzzleWorkflow(props) {
    const [currentStep, setCurrentStep] = useState(0);
    const navigate = useNavigate();

    const confettiDefaultColors = ['#ff0000', '#00ff00', '#0000ff', '#ff00ff', '#ffff00', '#00ffff', '#ff8800', '#8800ff'];

    const [snippetData, setSnippetData] = useState({snippetName: '', snippetDesc: '', 
                  webPageSettings: {coverAddEffect: false, confettiAddEffect: false, confettiColors: confettiDefaultColors, selectedWebPageId: 3, templatePropValuesCollection: [], ctaButtonCorners: 'rounded', expiryDate: dayjs().add(24, 'hour').toJSON(), expiryTimezoneId: 'Europe/London' },
                  snippetSettings: {puzzleImgB64: '', }});
    const [emailImgFrames, setEmailImgFrames] = useState([]); //helper var. Oly used to store the image frames when emailMode = dynamic


    const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [progress, setProgress] = useState(0) //from 0 to 100

    const [activeErrorList, setActiveErrorList] = useState([]);

    const puzzleManagerRef = useRef();


    let params = useParams();
    useEffect(() => {
      if (params.snippetId !== undefined) {
        getSnippetInfo(params.snippetId)
      }
    }, [props.snippetId])

    const getSnippetInfo = async (snippetId) => {
      
      try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
        const response = await axios.get(url);
        const data = response.data;

        const newSnippetData = response.data;
        newSnippetData.snippetSettings = JSON.parse(response.data.snippetSettings);
        newSnippetData.webPageSettings = JSON.parse(response.data.webPageSettings);
        //console.log(newSnippetData.webPageSettings)
        //adding new metadata for compatibility with old tags that don't have it
        if (newSnippetData.webPageSettings.confettiColors === undefined) newSnippetData.webPageSettings.confettiColors = confettiDefaultColors;
        const ctaBtnCorners = newSnippetData.webPageSettings.templatePropValuesCollection.find(pv => pv.propName === 'cta-border-radius')
        if (ctaBtnCorners === undefined) newSnippetData.webPageSettings.templatePropValuesCollection.push({propName: 'cta-border-radius', propValue: 'rounded'})
        setSnippetData(newSnippetData)


      } catch (error) {
        console.log(error);
      }
      
    }

    const submitDataSnippet = async () => {
      setShowLoader(true);
      setSuccessHtmlMsg('');
    
      try {
          let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/20`;
          if (params.snippetId !== null && params.snippetId !== undefined) url = `${process.env.REACT_APP_LION_API_URL}/Snippets/update/20/${params.snippetId}`;

          

          const dataToPost = {...snippetData, href: '', snippetSettings: JSON.stringify(snippetData.snippetSettings), 
                              webPageSettings: JSON.stringify(snippetData.webPageSettings)}

          const response = await axios.post(url, dataToPost);

          if (snippetData.snippetSettings.puzzleSettings.emailMode === 'dynamic') {
            const snippetId = GetSnippetIdfromSnippetHtml(response.data)
            await uploadSnippetAssets(snippetId)
          }
    
          setSuccessHtmlMsg(response.data);
          setShowSuccessMsg(true);
      } catch (error) {
        setShowSuccessMsg(false);
        setShowErrorMsg(true);
        console.log(error);
      }
      setShowLoader(false);
      setSubmitted(true)

      return true;
    }

    const uploadSnippetAssets = async (snippetId) => {
      let currentProgress = 30
      setProgress(currentProgress)

      setShowLoader(true);
      setSuccessHtmlMsg('');
    
      try {
          //const slicesToProcess = snippetData.wheelSettings.slices.filter(s => s.notUsed === false)
          const delta = 70;


          let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/puzzle/${snippetId}/0`;
          

          let dataToPost = {framesInfo: emailImgFrames.map(f => {return {frame: f}})}

          const response = await axios.post(url, dataToPost);
          currentProgress += delta;
          setProgress(currentProgress)          

          
          setShowSuccessMsg(true);
      } catch (error) {
        setShowSuccessMsg(false);
        setShowErrorMsg(true);
        console.log(error);
      }
      setShowLoader(false);
      setSubmitted(true)

      return true;
    }

  const handleElementChange = async (snippetInfo) => {
    if (snippetData.snippetSettings.puzzleImgB64 !== snippetInfo.snippetSettings.puzzleImgB64) {
        //if the puzzle image has changed we want to run a custom validation
        //also if there was an image change then the second paramater will have the new image size
        
        const dataURL = snippetInfo.snippetSettings.puzzleImgB64;
        if (dataURL !== '') {
            const size = await GetImageSize(dataURL);
            //console.log(snippetInfo)
              if (snippetInfo.snippetSettings.puzzleSettings === undefined) snippetInfo.snippetSettings.puzzleSettings = {}
              snippetInfo.snippetSettings.puzzleSettings.canvasWidth = size.width
              snippetInfo.snippetSettings.puzzleSettings.canvasHeight = size.height
        }

    }
    else
    {

        if (activeErrorList.length > 0) {
            try {
                snippetDataValidationSchemaSlidingPuzzle.validateSync(snippetInfo, {abortEarly: false});
                setActiveErrorList([])
            }
            catch (e) {
                const errorList = getErrorListFromYupError(e)
                setActiveErrorList(errorList)
                return;
            }  
        }
    }
    setSnippetData(snippetInfo)


    //console.log(snippetInfo)
  }

  const handleNavChange = async(navInfo) => {
    if (navInfo.actionType === 'Navigation'){
      //if we are moving from 0 to 1 we need to apply some validation
      if (currentStep === 0 && navInfo.nextIndex === 1) {
        try {
          //console.log(snippetData)
          snippetDataValidationSchemaSlidingPuzzle.validateSync(snippetData, {abortEarly: false});
          setActiveErrorList([])
        }
        catch (e) {
          //console.log(JSON.parse(JSON.stringify(e)))
          const errorList = getErrorListFromYupError(e)
          //legacy issue: yup can return also href errors that we don't validate anymore
          // in this step. We need to supress this error here
          const hrefErrorIndex = errorList.findIndex(e => e.fieldName === 'snippetSettingsRevealHref');
          if (hrefErrorIndex !== -1) errorList.splice(hrefErrorIndex, 1);
          
          
          console.log(errorList)
          setActiveErrorList(errorList)
          if (errorList.length > 0) return false;
        }    
      }
      if ((currentStep === 1 && navInfo.nextIndex === 2)) {
        if (snippetData.snippetSettings.puzzleSettings.emailMode === 'custom') {
          //simple validation needed
          if (snippetData.snippetSettings.puzzleSettings.emailCustomImage === undefined || snippetData.snippetSettings.puzzleSettings.emailCustomImage.length === 0) {
            //we need to build a yup error
            setActiveErrorList([{fieldName: 'emailCustomImage', message: 'You must upload an image'}])
            return
          }
          else setActiveErrorList([])
        }
        if (snippetData.snippetSettings.puzzleSettings.emailMode === 'dynamic') {
          setShowLoader(true)
          const frames = await puzzleManagerRef.current.askFrames()
          setEmailImgFrames(frames)
          //downloadDataURLImages(frames)
          setShowLoader(false)
        }
        let newPuzzleSettings = {...snippetData.snippetSettings.puzzleSettings}
        if (snippetData.snippetSettings.puzzleSettings.emailMode === 'static') {
          setShowLoader(true)
          const img = await puzzleManagerRef.current.askImage()
          //const newPuzzleSettings = {...snippetData.snippetSettings.puzzleSettings, emailStaticImage: img}
          //handleSnippetSettingChange('puzzleSettings', newPuzzleSettings)
          newPuzzleSettings = {...newPuzzleSettings, emailStaticImage: img}

          setShowLoader(false)
        }
        
         if (snippetData.snippetSettings.puzzleSettings.emailMode !== 'custom') {
          //if a custom image is NOT used then we want to clear any custom image that could have been uploaded
          //const newPuzzleSettings = {...snippetData.snippetSettings.puzzleSettings, emailCustomImage: ''}
          //handleSnippetSettingChange('puzzleSettings', newPuzzleSettings)
          newPuzzleSettings = {...newPuzzleSettings, emailCustomImage: ''}
         }
        handleSnippetSettingChange('puzzleSettings', newPuzzleSettings)

      }
      setCurrentStep(navInfo.nextIndex);
    }
    else if (navInfo.actionType === 'Submit') {
      try {
        //console.log(snippetData)
        snippetDataValidationSchemaSlidingPuzzle.validateSync(snippetData, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        // IF VALIDATION IS NO PASSED WE RETURN AND DO NOTHING ELSE

        //console.log(JSON.parse(JSON.stringify(e)))
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return;
      }

      //if we are here then the validastion is passed
      setCurrentStep(navInfo.nextIndex);
      submitDataSnippet()
      
    }
  }
    
    const handleSaveExitClicked = () => {
        navigate("/ph/slidingPuzzle")
    }
    const handleClose = () => {
        navigate("/ph/slidingPuzzle")
    }
    
  const handleSnippetSettingChange = (propName, propValue) => {
    const newSettings = {...snippetData.snippetSettings, [propName]: propValue}
    const newSnippetData = {...snippetData, snippetSettings: newSettings}

    //console.log(newSnippetData)
    setSnippetData(newSnippetData)
  }
  const handleElementWebPageChange = (settings) => {
    const newSettings = {...snippetData, webPageSettings: settings}
    //console.log(newSettings)
    setSnippetData(newSettings)

  }



    return <div>
        <CcStepper2
            steps={[{ name: 'Puzzle Image', href: '#' },
                    { name: 'Email cover', href: '#' },
                    { name: 'Puzzle', href: '#' },
                    { name: 'Get Element', href: '#' },
                ]}
            currentStepIndex={currentStep}
        />
        <div className="border border-2 border-gray-200 rounded-md p-2">

            {currentStep === 0 && <SlidingPuzzleElementAssetsManager
                                    onChange={handleElementChange}
                                    validationErrorsList={activeErrorList}
                                    snippetInfo={snippetData}
              />}
            {currentStep === 1 && <>
              <PuzzleManager imageDataUrl={snippetData.snippetSettings.puzzleImgB64}
              ref={puzzleManagerRef}
              settings={snippetData.snippetSettings.puzzleSettings}
              onPuzzleSettingsChange={(settings) => handleSnippetSettingChange('puzzleSettings', settings)}
              validationErrorsList={activeErrorList}
              />
              {showLoader && <div className='flex flex-col items-center'>
                <div className='mt-14'><CcLoader size={96} /></div>
                <div className='font-poppins text-sm font-semibold'>Working...</div>
                </div>}
            </>
            }
            {currentStep === 2 && <>
              <SlidingPuzzleElementWebPageManager
                                    onChange={handleElementWebPageChange}
                                    //onChangeRevealImages={handleRevealImagesChange}
                                    snippetInfo={snippetData}
                                    validationErrorsList={activeErrorList}
                                    //ref={elementWebPageManagerRef}
              />
              <WebPagePreviewer 
                                    snippetInfo={snippetData}
                                    //onRequestPointerB64={handleRequestPointerB64}
              />

            </>

            }

            {currentStep === 3 && <div className='flex flex-col items-center'>
                {!showLoader && !showSuccessMsg && !showErrorMsg && <div>Confirm</div> }
                {showLoader && <div className='py-12'><CcLoader size={96} /></div> }
                {showSuccessMsg && <SnippetCodeViewer forScrachOff numSnippets={1} html={successHtmlMsg} />}
                {(showSuccessMsg || showErrorMsg) && <div> <CcActionButton variant="contained" onClick={handleClose} >Close</CcActionButton></div>}
            </div>}

            {currentStep !== 3 && !showLoader &&
                    <StepperNavButtons totalSteps={4}
                    currentStepNum={currentStep}
                    onChange={handleNavChange}
                    showClose={submitted}
                    onClose={handleClose}
                />
            }
        </div>

    </div>
}